module.exports = __webpack_public_path__ + "fa020819a168df8f3b4028294ba19411.pdf";